export default "__VITE_PUBLIC_ASSET__4bc3655a__"